module.exports = __webpack_public_path__ + "img/logo_ebike.1e8c6b13.png";